import { FormlyFieldConfig } from 'ng-formly';
export const activityFields: Array<FormlyFieldConfig> = [
    {
        key: 'subject',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            required: true,
            label: 'Subject*'
        }
    },
    {
        key: 'activityDate',
        type: 'datepicker',
        templateOptions: {
            placeholder: '',
            required: true,
            type: 'date',
            label: 'Date*'
        }
    },
    {
        key: 'accountId',
        hideExpression: 'model.Type !== "task"',
        type: 'user-select',
        templateOptions: {
            placeholder: '',
            required: true,
            label: 'Assigned To*'
        }
    },
    {
        key: 'comments',
        type: 'textarea-field',
        templateOptions: {
            required: true,
            label: 'Comments*'
        }
    },
    {
        key: 'entityrecordId',
        type: 'input-field',
        hideExpression: true,
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Related To'
        }
    },
    {
        key: 'entityId',
        type: 'input-field',
        hideExpression: true,
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Entity'
        }
    },

    {
        key: 'status',
        type: 'select-component',
        hideExpression: "!model.id",
        templateOptions: {
            options: [{
                label: 'Open',
                value: 'open'
            }, {
                label: 'Completed',
                value: 'completed'
            }],
            label: 'Status',
            required: true,
            default: 'open'
        }
    },
    {
        key: 'type',
        type: 'select-component',
        templateOptions: {
            options: [{
                label: 'Task',
                value: 'task'
            }, {
                label: 'Call',
                value: 'call'
            }, {
                label: 'Visit',
                value: 'visit'
            }, {
                label: 'Event',
                value: 'event'
            }],
            label: 'Activity Type',
            required: true,
            default: 'task'
        }
    },
    {
        key: 'priority ',
        type: 'select-component',
        hideExpression: "!model.id",

        templateOptions: {
            options: [{
                label: 'High',
                value: 'high'
            }, {
                label: 'Medium',
                value: 'medium'
            }, {
                label: 'Low',
                value: 'low'
            }],
            label: 'Priority',
            required: true,
            default: 'medium'
        }
    }

];



// WEBPACK FOOTER //
// ./src/app/shared/formfields/activity.ts